/* A due date and its standing (U3). Tokens only. */

.note {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px 8px;
}

.ahead,
.none {
  color: var(--muted);
  font-size: var(--t-min);
}
